const THEME_COLORS = ["dark", "light", "primary", "secondary"];

function resolveThemeSource(x, y, body, overlay) {
  if (body.classList.contains("menu-overlay-open") && overlay) {
    return overlay;
  }

  const hit = document.elementFromPoint(x, y);
  const themed = hit?.closest("[data-theme]");
  if (themed) return themed;

  const bodyTheme = THEME_COLORS.find((color) => body.classList.contains(`theme-${color}`));
  if (bodyTheme) return body;

  return document.documentElement;
}

function readCursorColor(source) {
  const color = getComputedStyle(source).getPropertyValue("--cursor-color").trim();
  return color || null;
}

export function initCursor() {
  const dot = document.querySelector(".cursor-dot");
  const label = document.querySelector(".cursor-label");
  const body = document.body;
  const overlay = document.querySelector(".menu-overlay");

  if (!dot || !label || window.matchMedia("(max-width: 991px)").matches) return;

  let x = window.innerWidth / 2;
  let y = window.innerHeight / 2;
  let dx = x;
  let dy = y;

  const setMode = (mode) => {
    body.classList.remove("cursor-link", "cursor-preview", "cursor-zoom", "cursor-active", "cursor-slider");
    if (!mode) return;
    body.classList.add(`cursor-${mode}`, "cursor-active");
  };

  const applyThemeColor = () => {
    const source = resolveThemeSource(x, y, body, overlay);
    const color = readCursorColor(source);
    if (color) {
      dot.style.setProperty("--cursor-color", color);
    } else {
      dot.style.removeProperty("--cursor-color");
    }
  };

  window.addEventListener("mousemove", (event) => {
    x = event.clientX;
    y = event.clientY;
  });

  document.querySelectorAll("[data-cursor]").forEach((target) => {
    target.addEventListener("mouseenter", () => setMode(target.dataset.cursor));
    target.addEventListener("mouseleave", () => setMode(""));
  });

  const tick = () => {
    const easing = 0.1;
    dx += (x - dx) * easing;
    dy += (y - dy) * easing;
    dot.style.left = `${dx}px`;
    dot.style.top = `${dy}px`;
    label.style.left = `${dx + 26}px`;
    label.style.top = `${dy - 22}px`;
    applyThemeColor();
    requestAnimationFrame(tick);
  };

  applyThemeColor();
  tick();
}
